require("../../scss/app-default.scss");

import Application from "./application";
import BackgroundImageBehaviour from '../behaviours/background-image-behaviour';
import MobileMenuBehavior from "../behaviours/mobile-menu-behaviour";
import EqualizeBehavior from "../behaviours/equalize-behaviour";
import ShortlistCount from "../jsx/shortlist/shortlist-count";
import ShortlistButton from '../jsx/shortlist/shortlist-button';
import ReviewForm from '../jsx/reviews/form';
import ToggleClassBehavior from "../behaviours/toggle-class-behaviour";
import BlockEventBehaviour from "../behaviours/block-event-behaviour";


let config = {};
config.behaviours = {
    "BackgroundImage": new BackgroundImageBehaviour(),
    "MobileMenuBehaviour": new MobileMenuBehavior(),
    "EqualizeBehaviour": new EqualizeBehavior(),
    'ToggleClassBehaviour': new ToggleClassBehavior(),
    'BlockEventBehaviour': new BlockEventBehaviour()
};

config.components = {
    "shortlist-count": ShortlistCount,
    "review-form": ReviewForm,
    "shortlist-button": ShortlistButton,
};

new Application(config);





